import axios from 'axios';
import { API_PATH } from '../../../constants';
import * as actions from './actions';
import * as selectors from './selectors';
import * as incidentSelectors from '../incidents/selectors';

import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const options = {
  name: 'dashboards',
  baseType: 'DASHBOARDS',
  apiEndpoint: 'dashboards/dashboards/'
};

const fetchCurrentDashboard = id => dispatch => {
  dispatch(defaultOperations.fetch(id));
  dispatch(actions.setCurrentDashboard(id));
};

const getDashboardAuthToken = id => dispatch =>
  axios
    .get(`${API_PATH}/dashboards/dashboards/${id}/auth_token`)
    .then(response => dispatch(actions.dashboardAuthTokenReceived(response.data)));

// when creating a new dashboard, we immediately redirect to it, therefore
// we don't need to dispatch anything, for now.
const createDashboard = (group_id, type, template_id) => () =>
  axios.post(`${API_PATH}/dashboards/dashboards`, { group_id, type, template_id }).then(response => response.data);

const updateWidgets = (widgets, pageIndex) => dispatch => dispatch(actions.updateWidgets(widgets, pageIndex));

const removeWidget = widgetId => dispatch => dispatch(actions.removeWidget(widgetId));

const addWidget = (widget, pageIndex) => dispatch => dispatch(actions.addWidget(widget, pageIndex));

const setEditMode = editMode => dispatch => dispatch(actions.setEditMode(editMode));

const updateWidget = (widgetId, fields) => dispatch => dispatch(actions.updateWidget(widgetId, fields));

const setDashboardDatetime = dateTime => dispatch => dispatch(actions.setDashboardDateTime(dateTime));

const unlockDashboardDatetime = () => dispatch => dispatch(actions.unlockDashboardDatetime());

const setDisplayedIncidentId = (id, force) => dispatch => dispatch(actions.setDisplayedIncidentId(id, force));

const displayNextIncident = () => (dispatch, getState) => {
  const currentIncident = incidentSelectors.selectCurrentDisplayedIncident(getState());
  const displayableIncidents = incidentSelectors.selectDisplayableIncidents(getState());

  let currentIndex = displayableIncidents.indexOf(currentIncident);
  currentIndex = Math.max(currentIndex, 0);

  const nextIncident = displayableIncidents[(currentIndex + 1) % displayableIncidents.length];

  dispatch(setDisplayedIncidentId(nextIncident?.id || displayableIncidents[0].id));
};

const lockIncident = lockValue => dispatch => {
  dispatch(actions.lockIncident(lockValue));
};

const activateIncidentMode = () => (dispatch, getState) => {
  const { page_type } = selectors.selectActivePage(getState());
  if (page_type === undefined || page_type === 'incident') return;
  return dispatch(actions.activateIncidentMode());
};

const updateWidgetSettings = (widgetId, fields) => dispatch => {
  dispatch(actions.updateWidgetSettings(widgetId, fields));
};

// allows two modes of calling:
// updateCurrentDashboardFields('fieldName', value) or
// updateCurrentDashboardFields({fieldName: value, fieldName2: value2})
const updateCurrentDashboardFields = (fieldNameOrValues, value) => (dispatch, getState) => {
  if (value !== undefined && typeof fieldNameOrValues === 'string') {
    fieldNameOrValues = { [fieldNameOrValues]: value };
  }

  const { id } = selectors.selectCurrentDashboard(getState());
  return dispatch(defaultOperations.updateFields(id, fieldNameOrValues));
};

const activateNormalMode = () => (dispatch, getState) => {
  const { page_type } = selectors.selectActivePage(getState());
  if (page_type === undefined || page_type === 'normal') return;
  return dispatch(actions.activateNormalMode());
};

const defaultOperations = createMetadataAPIOperations(options);

export default {
  ...defaultOperations,
  fetchCurrentDashboard,
  getDashboardAuthToken,
  createDashboard,
  updateWidgets,
  updateWidget,
  updateWidgetSettings,
  removeWidget,
  addWidget,
  setDashboardDatetime,
  unlockDashboardDatetime,
  setDisplayedIncidentId,
  displayNextIncident,
  activateIncidentMode,
  activateNormalMode,
  updateCurrentDashboardFields,
  setEditMode,
  lockIncident
};
